import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import dayjs from 'dayjs';
import qs from 'query-string';

import { CONTEXT, WEB_STORE } from '../../config';
import {
  setIframeVisible,
  setFasterProduct,
  setShareVisible,
  setShareLink,
} from '../../actions/layout';
import Button from '../../components/Button/Button';
import Rate from '../../components/Rate/Rate';
import { logging, logPostInfo } from '../../actions/log';
import styles from './SoftDetailMore.module.less';
import { logNative, getUrlByTargetContent, formatMoney } from '../../utils/utils';
// import { addCollectSpecial, deleteCollectSpecial } from '../../actions/collection';
// import { getAppDetails } from '../../actions/detail';
import Btn from '../../components/Btn/Btn';
import SoftTag from '../../components/SoftTag/SoftTag';
import useLoginStatus, { handleLogin } from '../../utils/hooks/useLoginStatus';
import Config from './config';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ softDetails, match, updateSoftDetails, handleDowm }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const logInfoData = useSelector(selectLogInfo);
  const [isCollect, setIsCollect] = useState(false);
  const loginStatus = useLoginStatus();
  const init = useRef(null);
  const search = qs.parse(location?.search) || {};
  const onDetailsActivity = useCallback((bannerInfo, flag) => {
    dispatch(
      logging({
        category: 'C',
        action: flag === 'rank' ? 'AppDetail_Rank' : 'AppDetail_Activity',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softDetails.softID,
          softType: '0',
          targetContent: bannerInfo.targetContent ? JSON.parse(bannerInfo.targetContent) : {},
        },
        param3: softDetails.bizInfo,
      }),
    );
    if (
      bannerInfo.targetType === '1' ||
      bannerInfo.targetType === '3' ||
      bannerInfo.targetType === '11'
    ) {
      dispatch(
        logPostInfo({
          source_p: `AppDetail||${flag === 'rank' ? 'AppDetail_Rank' : 'AppDetail_Activity'}`,
          source_pp: logInfoData.source_p,
        }),
      );
      let url = `${CONTEXT}/`;
      if (bannerInfo.targetType && bannerInfo.targetContent) {
        url = getUrlByTargetContent(bannerInfo);
      }
      history.push(url);
    } else if (bannerInfo.targetType === '2') {
      if (bannerInfo.targetUrl) {
        window.open(bannerInfo.targetUrl);
      } else if (bannerInfo.targetContent) {
        if (typeof bannerInfo.targetContent === 'string') {
          try {
            const targetContent = JSON.parse(bannerInfo.targetContent) || {};
            window.open(targetContent.targetUrl);
          } catch (error) {}
        } else if (bannerInfo.targetContent.targetUrl) {
          window.open(bannerInfo.targetContent.targetUrl);
        }
      }
    } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
      let targetContent = {};
      try {
        targetContent = JSON.parse(bannerInfo.targetContent);
      } catch (error) {
        logNative(`分析商城URL JSON解析错误:${error}`, error);
      }
      if (targetContent && targetContent.url) {
        dispatch(
          setIframeVisible({
            visible: true,
            url: targetContent.url,
            source: 'softDetail',
          }),
        );
      }
    }
  });

  // // 写入登录状态
  // useEffect(() => {
  //   if (init.current) {
  //     const timer = setTimeout(() => {
  //       dispatch(
  //         getAppDetails({
  //           softid: match.params.id || '',
  //           bizInfo: match.params.bizInfo || {},
  //         }),
  //       );
  //       clearTimeout(timer);
  //     }, 500);
  //   }
  //   init.current = true;
  // }, [loginStatus]);

  const handleCollect = async () => {
    setIsCollect(true);
    if (!loginStatus) {
      // 调用登陆
      handleLogin(); // 未登录 调用登录弹窗
      return;
    }
    setIsCollect(false);
    if (!softDetails.hasCollect) {
      const data = await Config.addCollectSpecial(
        {
          targetId: softDetails.softID || softDetails.SoftID,
          targetType: 'pc',
        },
        softDetails,
      );
      updateSoftDetails(data);
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_Collect',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softDetails.softID,
            softType: '0',
          },
          param3: softDetails.bizInfo,
        }),
      );
    } else {
      const data = await Config.deleteCollectSpecial(
        {
          targetId: softDetails.softID || softDetails.SoftID,
          targetType: 'pc',
        },
        softDetails,
      );
      updateSoftDetails(data);
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_Collect_Cancel',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softDetails.softID || softDetails.SoftID,
            softType: '0',
          },
          param3: softDetails.bizInfo,
        }),
      );
    }
  };

  useEffect(() => {
    if (isCollect && loginStatus) {
      handleCollect();
    }
  }, [loginStatus, isCollect]);

  const handleFasterProduct = () => {
    dispatch(
      setFasterProduct({
        soft: { ...softDetails, bizInfo: match.params.bizInfo },
        info: { isFasterProduct: true, from: 'soft' },
        logInfo: { source: 'AppDetail' },
      }),
    );
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Accelerate',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softDetails.softID || softDetails.SoftID,
          accelerate: softDetails.appRecommend && softDetails.appRecommend.softId,
          softType: '0',
        },
        param3: softDetails.bizInfo,
      }),
    );
  };

  const handleShare = () => {
    dispatch(setShareVisible(true));
    dispatch(
      setShareLink({
        address: `${WEB_STORE}/detail/${softDetails.softID}`,
        desc: `${softDetails.detailInfo.slice(0, 50)}${
          softDetails.detailInfo.length > 50 ? '...' : ''
        }`,
        info: { from: 'soft' },
        logInfo: { source: 'AppDetail' },
        soft: { ...softDetails, bizInfo: match.params.bizInfo },
      }),
    );
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Store_Share',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softDetails.softID || softDetails.SoftID,
          softType: '0',
        },
        param3: softDetails.bizInfo,
      }),
    );
  };

  // 标签跳转
  const handleLabel = useCallback(
    label => () => {
      let code = '';
      try {
        code = JSON.parse(label.targetContent).code;
        // eslint-disable-next-line no-empty
      } catch (er) {}
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_Label',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softDetails.softID || softDetails.SoftID,
            softType: '0',
            code,
          },
          param3: softDetails.bizInfo,
        }),
      );
      dispatch(
        logPostInfo({
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );
      let url = `${CONTEXT}/`;
      if (label.targetType && label.targetContent) {
        url = getUrlByTargetContent(label);
      }
      history.push(`${url}&source_detail=Lable_Rank`);
    },
    [],
  );

  const formatDiscount = (current, original) => {
    let cp = parseFloat(current);
    let op = parseFloat(original);
    if (cp > 0 && op > 0) {
      let discont = parseFloat((cp / op) * 10).toFixed(1);
      if (discont.indexOf('.0') > -1) {
        return discont.slice(0, discont.length - 2);
      }
      if (discont === '0') {
        return '0.1';
      }
      return discont;
    }
    return '0';
  };

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);

  const handleDownload = () => {
    handleDowm(true);
  };

  // 8.7 多了游戏预约的字段处理按钮显示的文字
  const handleText = info => {
    if (info?.appBizType === 0 || info?.appBizType === 1) {
      if (info?.androidType === '3') {
        if (
          info?.sourceInfo &&
          info?.sourceInfo?.sellInfo &&
          (info?.sourceInfo?.sellInfo?.originalPrice || info?.sourceInfo?.sellInfo?.currentPrice)
        ) {
          return '立即购买';
        } else {
          return '立即下载';
        }
      } else {
        return '立即安装';
      }
    } else {
      if (info?.appBizContent) {
        return '立即预约';
      } else {
        if (info?.androidType === '3') {
          if (
            info?.sourceInfo &&
            info?.sourceInfo?.sellInfo &&
            (info?.sourceInfo?.sellInfo?.originalPrice || info?.sourceInfo?.sellInfo?.currentPrice)
          ) {
            return '立即购买';
          } else {
            return '立即下载';
          }
        } else {
          return '立即安装';
        }
      }
    }
  };

  return (
    <div
      className={`${styles.detail_infos} ${softDetails &&
        softDetails.cover &&
        styles.detail_infos_cover}`}
    >
      <div className={styles.detail}>
        <div className={styles.detail_logo}>
          <img className={styles.detail_img} src={softDetails.logoFile} />
        </div>
        <div className={styles.detail_info}>
          <div className={styles.detail_info_row1}>
            <div className={styles.detail_info_row1_column1}>
              <div className={styles.detail_info_row1_line1}>
                <div
                  className={styles.detail_info_title}
                  title={`${
                    softDetails.softName && softDetails.softName.length > 6
                      ? softDetails.softName
                      : ''
                  }`}
                >
                  {softDetails.softName}
                </div>
                {softDetails.score > 70 && (
                  <div className={styles.detail_info_score}>
                    <Rate score={(softDetails.score / 20).toFixed(1)} />
                  </div>
                )}
              </div>

              {softDetails.detailsTag && (
                <div className={styles.detail_info_row1_line2}>
                  {softDetails.detailsTag.map((tag, i) => (
                    <div className={styles.detail_info_tag} key={i} title={tag.tips}>
                      {/* {tag.name === '无忧退' && (
                        <img className={styles.detail_info_img} src={tag.icon} alt="i" />
                      )}
                      {tag.name !== '无忧退' && (
                        <>
                          <img className={styles.detail_info_tag_icon} src={tag.icon} alt="i" />
                          <span className={styles.detail_info_tag_text}>{tag.name}</span>
                        </>
                      )} */}
                      <img className={styles.detail_info_tag_icon} src={tag.icon} alt="i" />
                      <span className={styles.detail_info_tag_text}>{tag.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              className={`${styles.detail_info_row1_column2} ${
                softDetails.androidType === '3' ? styles.detail_info_row1_type3 : ''
              }`}
            >
              {softDetails.androidType !== '3' && (
                <div className={styles.detail_info_row1_column2_1}>
                  <div className={classNames(styles.collect)} onClick={handleCollect} title="收藏">
                    <i
                      className={classNames(
                        'iconfont',
                        softDetails.hasCollect ? 'icon-collected_soft' : 'icon-collect_soft',
                      )}
                    />
                  </div>
                  <div className={styles.share} title="分享" onClick={handleShare}>
                    <i className={classNames('iconfont icon-share_soft')} />
                  </div>
                </div>
              )}

              {softDetails.androidType !== '3' && softDetails && softDetails.appRecommend && (
                <Btn className={styles.fasterProductBtn} handleClick={handleFasterProduct}>
                  <div className={styles.fasterProductIcon} />
                  <span className={styles.fasterProductBtnText}>加速</span>
                </Btn>
              )}
              <div onClick={handleDownload}>
                <Button
                  soft={{ ...softDetails, bizInfo: match.params.bizInfo }}
                  info={{
                    className: styles.soft_btn,
                    className_busing: styles.soft_btn_busing,
                    className_open: styles.soft_button_open,
                    text: handleText(softDetails),
                    // softDetails?.appBizType === 0
                    //   ? softDetails.androidType === '3'
                    //     ? softDetails.sourceInfo &&
                    //       softDetails.sourceInfo.sellInfo &&
                    //       (softDetails.sourceInfo.sellInfo.originalPrice ||
                    //         softDetails.sourceInfo.sellInfo.currentPrice)
                    //       ? '立即购买'
                    //       : '立即下载'
                    //     : '立即安装'
                    //   : '立即预约',
                    isCompetitive: true,
                    isFasterProduct: true,
                  }}
                  logInfo={{
                    source: 'AppDetail',
                    isSearch: search?.isSearch,
                    // logInfoData.source_p &&
                    // (logInfoData.source_p.indexOf('Search') > -1 ||
                    //   logInfoData.source_p.indexOf('Search_Try') > -1 ||
                    //   logInfoData.source_p.indexOf('Search_Lenovo') > -1),
                  }}
                />

                {softDetails?.appBizType !== 0 && softDetails?.appBizContent?.expectedReleaseTime && (
                  <div className={styles.soft_buyInfos}>
                    <div className={`listing_time`}>
                      {softDetails?.appBizContent?.expectedReleaseTime}上架
                    </div>
                  </div>
                )}
              </div>

              {softDetails && softDetails?.payType === 1 && (
                <div className={styles.soft_buyInfos}>
                  {softDetails?.originalPrice &&
                    softDetails?.currentPrice &&
                    softDetails?.originalPrice !== softDetails?.currentPrice && (
                      <>
                        <div className={`soft_buyInfos_zk`}>
                          {formatDiscount(softDetails?.currentPrice, softDetails?.originalPrice)}折
                        </div>
                        <div className={`soft_buyInfos_cp`}>
                          <span className={`soft_buyInfos_cp_1`}>￥</span>
                          <span className={`soft_buyInfos_cp_2`}>
                            {formatMoney(parseFloat((softDetails?.currentPrice || 0) / 100))}
                          </span>
                        </div>
                        <div className={`soft_buyInfos_op`}>
                          ￥{formatMoney(parseFloat((softDetails?.originalPrice || 0) / 100))}
                        </div>
                      </>
                    )}

                  {((!softDetails?.originalPrice && softDetails?.currentPrice) ||
                    (softDetails?.originalPrice && !softDetails?.currentPrice) ||
                    (softDetails?.originalPrice &&
                      softDetails?.currentPrice &&
                      softDetails?.originalPrice === softDetails?.currentPrice)) && (
                    // {((!softDetails?.originalPrice && softDetails?.currentPrice) ||
                    //   (softDetails?.originalPrice && !softDetails?.currentPrice)) && (
                    <>
                      <div className={`soft_buyInfos_cp`}>
                        <span className={`soft_buyInfos_cp_1`}>￥</span>
                        <span className={`soft_buyInfos_cp_2`}>
                          {formatMoney(
                            parseFloat(
                              (softDetails?.currentPrice || softDetails?.originalPrice || 0) / 100,
                            ),
                          )}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              )}
              {softDetails && softDetails?.androidType === '3' && softDetails?.sourceInfo && (
                <div className={styles.soft_buyInfos}>
                  {softDetails?.sourceInfo?.sellInfo?.discount && (
                    <div className={`soft_buyInfos_zk`}>
                      {softDetails?.sourceInfo?.sellInfo?.discount} 折
                    </div>
                  )}
                  {softDetails?.sourceInfo?.sellInfo?.currentPrice ===
                    softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                    <>
                      {(softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                        !softDetails?.sourceInfo?.sellInfo?.originalPrice) ||
                        (!softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                          softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                            <div className="soft_buyInfos_cp">
                              <span className={`soft_buyInfos_cp_1`}>￥</span>
                              <span className={`soft_buyInfos_cp_2`}>
                                {formatPriceType3(
                                  softDetails?.sourceInfo?.sellInfo?.currentPrice ||
                                    softDetails?.sourceInfo?.sellInfo?.originalPrice,
                                )}
                              </span>
                            </div>
                          ))}
                      {softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                        softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.currentPrice)}
                            </span>
                          </div>
                        )}
                    </>
                  )}
                  {softDetails?.sourceInfo?.sellInfo?.currentPrice !==
                    softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                    <>
                      {softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                        !softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.currentPrice)}
                            </span>
                          </div>
                        )}
                      {!softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                        softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.originalPrice)}
                            </span>
                          </div>
                        )}
                      {softDetails?.sourceInfo?.sellInfo?.currentPrice &&
                        softDetails?.sourceInfo?.sellInfo?.originalPrice && (
                          <>
                            <div className={`soft_buyInfos_cp`}>
                              <span className={`soft_buyInfos_cp_1`}>￥</span>
                              <span className={`soft_buyInfos_cp_2`}>
                                {formatPriceType3(softDetails?.sourceInfo?.sellInfo?.currentPrice)}
                              </span>
                            </div>
                            <div className={`soft_buyInfos_op`}>
                              {`￥${formatPriceType3(
                                softDetails?.sourceInfo?.sellInfo?.originalPrice,
                              )}`}
                            </div>
                          </>
                        )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className={styles.detail_info_row2}>
            {softDetails.downloadCount && (
              <div className={styles.detail_info_item}>
                <span className={styles.detail_info_item_value}>
                  {softDetails.downloadCount}下载
                </span>
              </div>
            )}
            {softDetails.installFileSize && (
              <div className={styles.detail_info_item}>
                <span className={styles.detail_info_item_value}>{softDetails.installFileSize}</span>
              </div>
            )}
            {softDetails.createdTime && (
              <div className={styles.detail_info_item}>
                <span>更新时间：</span>
                <span className={styles.detail_info_item_value}>
                  {dayjs(softDetails.createdTime).format('YYYY-MM-DD')}
                </span>
              </div>
            )}
            {softDetails.version && (
              <div className={styles.detail_info_item}>
                <span>版本号：</span>
                <span className={styles.detail_info_item_value} title={softDetails.version}>
                  {softDetails.version}
                </span>
              </div>
            )}
          </div>
          {softDetails.appLabelList && (
            <div className={styles.detail_info_row3}>
              {softDetails.appLabelList.slice(0, 4).map((label, i) => (
                <div
                  key={i}
                  className={styles.detail_info_row3_column}
                  onClick={handleLabel(label)}
                >
                  <SoftTag data={label} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {softDetails.androidType !== '3' && softDetails.classRankingDesc && (
        <div
          className={styles.detail_rank}
          onClick={() => {
            onDetailsActivity(softDetails.classRankingDesc, 'rank');
          }}
        >
          <div className={styles.detail_rank_icon}>榜单</div>
          <div className={styles.detail_rank_text}>{softDetails.classRankingDesc.targetDesc}</div>
          <div className={`iconfont icon-point_right ${styles.detail_rank_point}`} />
        </div>
      )}
      {softDetails.editorRecommend && (
        <div
          className={styles.detail_reco}
          title={softDetails.editorRecommend.length > 50 ? softDetails.editorRecommend : ''}
        >
          <span className={styles.detail_reco_name}>推荐理由：</span>
          <span>{softDetails.editorRecommend}</span>
        </div>
      )}

      {softDetails.activityList && softDetails.activityList.length > 0 && (
        <div className={styles.detail_activity}>
          <span className={styles.detail_activity_name}>超值活动：</span>
          {softDetails.activityList.map((item, i) => (
            <span
              className={styles.detail_activity_item}
              onClick={() => {
                onDetailsActivity(item);
              }}
              key={i}
            >
              <span className={styles.detail_activity_text}>{item.activityDesc}</span>

              {item.targetType === '5' && (
                <>
                  <span className={styles.detail_activity_buy}>立即购买</span>
                  <span className={`iconfont icon-point_right ${styles.detail_activity_point}`} />
                </>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
});
